import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Divider } from '@snack-uikit/divider';
import { useNewListContext } from '../../Lists/contexts';
import styles from './styles.module.css';
export function PinTopGroupItem({ children }) {
    const { size = 's' } = useNewListContext();
    if (!children) {
        return null;
    }
    return (_jsxs("div", { className: cn(styles.pinTopItem), "data-size": size, "data-test-id": 'list__pin-top-group-item', children: [_jsx("div", { children: children }), _jsx(Divider, { weight: 'regular' })] }));
}
export function PinBottomGroupItem({ children }) {
    const { size = 's' } = useNewListContext();
    if (!children) {
        return null;
    }
    return (_jsxs("div", { className: cn(styles.pinBottomItem), "data-size": size, "data-test-id": 'list__pin-bottom-group-item', children: [_jsx(Divider, { weight: 'regular' }), _jsx("div", { children: children })] }));
}
